import { useMutation, useQuery } from 'react-query'
import axios, { getData } from 'lib/axios'
import { getMonth, getYear } from 'date-fns'

export const useGetBigCalendar = (apiFilter, calendarValue) => {
  const currentDate = {
    year: getYear(calendarValue),
    month: getMonth(calendarValue) + 1
  }

  const constructApiUrl = () => {
    let apiUrl = `/big-calendar?year=${currentDate.year}&month=${currentDate.month}`

    if (apiFilter) {
      apiUrl += '&' + apiFilter.map((filter) => `${filter.searchString}=[${filter.filteredData}]`).join('&')
    }

    return apiUrl
  }

  return useQuery(['big-calendar', constructApiUrl()], async () => {
    const result = await axios.get(constructApiUrl());
    return getData(result);
  });
}

export const useGetDisabledDate = (policyId) =>
  useQuery(
    ['disabled-date', policyId],
    async () => await axios.get(`/disabled-date?leave-policy=${policyId}`).then(getData)
  )

export const usePostValidateRequestDate = () => {
  return useMutation(async ({ policyId, datesArr }) => {
    const res = await axios.post(`/verify-date`, {
      leave_policy: policyId,
      dates: datesArr,
    })
    return res
  })
}
